import styled from "styled-components";

import { Skeleton } from "@mui/material";

export const StyledSim = styled.div`
  iframe {
    border-radius: 4px;
    @media screen and (max-width: 992px) {
      height: 550px;
    }
    @media screen and (max-width: 768px) {
      height: 250px;
    }
  }
  footer {
    grid-column-gap: 2rem;
    button.fullscreen-button {
      padding: 0.5rem 1.5rem;
      color: var(--blue-color-dark);
      font-size: var(--font-size-sm);
      border: var(--blue-color-dark) 1px solid;
      border-radius: 8px;
    }
    p {
      font-size: var(--font-size-base);
      span {
        font-size: var(--font-size-xs);
      }
    }
    .device-info {
      background: var(--dark-color);
      border-radius: 16px;
      padding: 0.25rem 1rem;
      display: flex;
      justify-content: space-between;
      grid-column-gap: 1rem;
      column-gap: 0.5rem;
      .icon:hover path {
        stroke: var(--secondary-color);
      }
    }
    @media screen and (max-width: 576px) {
      p {
        font-size: var(--font-size-xs);
      }
    }
  }
`;

export const StyledSkeleton = styled(Skeleton)`
  transform: none !important;
`;
